import { render, staticRenderFns } from "./DemoView.vue?vue&type=template&id=a6f553ac&"
import script from "./DemoView.vue?vue&type=script&lang=js&"
export * from "./DemoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports